import {
  kvpsBrandLetterToMdmEmailBrand,
  resolveMdmEmailBrandFromKvpsIdentifier,
} from "@/lib/cat/mdm-email-brand";

/** Full brand labels for `brandRelation.brandName` and `consent.brand`. */
export const MDM_BRAND_RELATION_NAMES: Record<string, string> = {
  VW: "Volkswagen",
  VN: "Volkswagen CV",
  AU: "Audi",
  SD: "SKODA",
  ST: "SEAT",
};

export type ResolvedMdmVehicleBrand = {
  mdmBrandCode: string;
  brandRelationName: string;
};

export function mdmBrandCodeToRelationName(
  mdmBrandCode: string | null | undefined,
): string | null {
  if (!mdmBrandCode?.trim()) return null;
  return MDM_BRAND_RELATION_NAMES[mdmBrandCode.trim().toUpperCase()] ?? null;
}

export function resolveMdmVehicleBrandFromKvps(
  draftKvps: string | null | undefined,
  owningDealerKvps?: string | null | undefined,
): ResolvedMdmVehicleBrand | null {
  const mdmBrandCode =
    resolveMdmEmailBrandFromKvpsIdentifier(draftKvps) ??
    resolveMdmEmailBrandFromKvpsIdentifier(owningDealerKvps);

  if (!mdmBrandCode) return null;

  const brandRelationName = mdmBrandCodeToRelationName(mdmBrandCode);
  if (!brandRelationName) return null;

  return { mdmBrandCode, brandRelationName };
}

export function kvpsBrandLetterToMdmBrandCode(
  letter: string | null | undefined,
): string | null {
  return kvpsBrandLetterToMdmEmailBrand(letter);
}
